import styled from "styled-components";
import React, { useEffect, useRef, useState } from "react";
import ThreeWrapper from "./ThreeWrapper";
import PlanetListWrapper from "./PlanetListWrapper";
import PopupPlanet from "./PopupPlanet";
import HomeUI from "./HomeUI";
import { PlanetProps, PlanetContentsProps } from "Data/planet";
import { useHomeLoaded, useCameraZoom } from "Provider/HomeProvider";
import { useLocation } from "react-router";
import { useHeaderState } from "Provider/AppProvider";
import useWindowSize from "Hooks/useWindowSize";
import { BREAKPOINT_TABLET } from "Styles/media";
import threeRender from "Threejs/render";
import theme from "Styles/theme";

// INTERFACE
export interface NowDataProps extends PlanetContentsProps {
	id: string;
}

const Inner = styled.div<{ active: boolean }>`
	height: 100%;
	opacity: ${(props) => (props.active ? 1 : 0)};
	overflow: hidden;
`;

const HomeView: React.FC<{ data: PlanetProps[] }> = ({ data }) => {
	const canvasRef = useRef<HTMLDivElement>(null);
	const [nowId, setNowId] = useState("");
	const { setHomeLoaded } = useHomeLoaded();
	const [hoverId, setHoverId] = useState("");
	const [hoverData, setHoverData] = useState({
		title: "",
		value: ""
	});

	const [nowData, setNowData] = useState<NowDataProps>();
	const { pathname } = useLocation();
	const { setHeaderState, initHeaderState } = useHeaderState();
	const { size } = useWindowSize();
	const { setValue } = useCameraZoom();

	useEffect(() => {
		const route = pathname.split("/")[1];
		if (route === "planet") {
			setNowData(undefined);
		}
	}, [pathname]);

	useEffect(() => {
		// popup control
		if (nowId && data) {
			data.forEach((el) => {
				if (el.id === nowId) {
					setNowData({ ...el.contents, id: el.id });
				}
			});
		} else {
			setNowData(undefined);
		}
	}, [nowId, data]);

	useEffect(() => {
		// SET NOWHOVER DATA
		if (data) {
			if (hoverId || nowId) {
				data.forEach((el) => {
					if (el.id === hoverId || el.id === nowId) {
						setHoverData({
							title: el.contents.title,
							value: el.contents.user.name
						});
					}
				});
			} else {
				setHoverData({
					title: "",
					value: ""
				});
			}
		}
	}, [hoverId, data, nowId]);

	useEffect(() => {
		if (size.width <= BREAKPOINT_TABLET) {
			if (nowId && pathname === "/") {
				setHeaderState((n) => ({ ...n, hide: true }));
			} else {
				setHeaderState((n) => ({ ...n, hide: false }));
			}
		} else {
			initHeaderState();
		}
		// eslint-disable-next-line
	}, [nowId, size, setHeaderState]);

	// RENDER THEE JS SCENE
	useEffect(() => {
		if (canvasRef !== null && canvasRef.current !== null && data !== undefined) {
			threeRender(canvasRef, setNowId, data, theme.size.zoom.init, setHoverId, setHomeLoaded, setValue);
		}
	}, [canvasRef, data, setNowId, setHoverId, setHomeLoaded, setValue]);

	return (
		<Inner active={pathname === "/"}>
			<ThreeWrapper canvasRef={canvasRef} data={data} setNowId={setNowId} setHoverId={setHoverId} />
			<PlanetListWrapper data={data} setNowId={setNowId} />
			<PopupPlanet data={nowData} setNowId={setNowId} />
			<HomeUI title={hoverData.title} value={hoverData.value} id={hoverId} setNowId={setNowId} />
		</Inner>
	);
};

export default HomeView;
